import { create } from 'zustand'
import { MatchVideo } from '../types'
import { apiClient } from '../utils/api'

interface VideoStore {
  videos: MatchVideo[]
  loading: boolean
  error: string | null
  fetchVideos: (playerId: string) => Promise<void>
  addVideo: (video: Omit<MatchVideo, 'id' | 'created_at' | 'updated_at'>) => Promise<void>
  deleteVideo: (id: string) => Promise<void>
}

export const useVideoStore = create<VideoStore>()(
  (set) => ({
    videos: [],
    loading: false,
    error: null,

    fetchVideos: async (playerId: string) => {
      set({ loading: true, error: null })
      try {
        const videos = await apiClient.getMatchVideos(playerId)
        set({ videos, loading: false })
      } catch (error) {
        set({ error: 'Failed to load videos', loading: false })
        console.error('Failed to fetch videos:', error)
      }
    },

    addVideo: async (video) => {
      set({ error: null })
      try {
        const newVideo = await apiClient.createMatchVideo(video)
        set((state) => ({ videos: [newVideo, ...state.videos] }))
      } catch (error) {
        set({ error: 'Failed to add video' })
        console.error('Failed to add video:', error)
        throw error
      }
    },

    deleteVideo: async (id: string) => {
      set({ error: null })
      try {
        await apiClient.deleteMatchVideo(id)
        set((state) => ({ videos: state.videos.filter((v) => v.id !== id) }))
      } catch (error) {
        set({ error: 'Failed to delete video' })
        console.error('Failed to delete video:', error)
        throw error
      }
    },
  })
)
